import axios from "axios";

const TRANS_URL = process.env.REACT_APP_TRANSACTION_API_URL;

export async function getPresignedURL(filename) {
  let reqBody = { filename }
  const response = await axios
    .post(TRANS_URL + "/attachment/getPresignURL", reqBody)
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      console.log("error => ", error);
      return { data: { message: "Unable to find request", status: false } };
    });
  console.log("response", response)
  return response.data.result;
}